import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaSignOutAlt } from "react-icons/fa";
import { getUser } from "../../utils/helper"
import { FaAngleDown } from "react-icons/fa";
import no_user from "../public/assets/img/no_user.png";


const Header = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const [userData, setUserData] = useState(null);
  const hasFetched = useRef(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleImageClick = () => {
    setShowMenu(!showMenu);
  };

  const handleLogout = async () => {
    try {
      await axios.get(`${API_BASE_URL}logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      localStorage.removeItem("token");

      document.cookie.split("; ").forEach((cookie) => {
        document.cookie = cookie.replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });

      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };


  useEffect(() => {
    const fetchUserData = async () => {
      if (!hasFetched.current) {
        const data = await getUser();
        setUserData(data?.data?.user || null);
        hasFetched.current = true;
      }
    };

    fetchUserData();
  }, []);

  return (
    <header className={`header ${isSidebarOpen ? "" : "sidebar-visible"}`} id="header">
      <nav className="navbar navbar-expand-lg white-box-shadow">
        <button onClick={toggleSidebar} className="toggle-btn rounded-2 px-2">
          ☰
        </button>

        <div className="d-flex flex-column ms-auto" ref={dropdownRef}>

          <div className="ms-auto d-flex py-1 px-3 rounded-1 cursor-pointer" onClick={handleImageClick}>
            <div className="profile-icon">
              <img
                src={
                  userData?.logo
                    ? `${userData.logo}`
                    : `${no_user}`
                }
                alt="Profile"
                className="rounded-circle"
                style={{ width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
              />
            </div>

            <div className="profile-expand-icon position-relative ms-1 d-flex">

              <FaAngleDown className="align-self-center" />
            </div>
          </div>

          {showMenu && (
            <div className="dropdown-box position-absolute mt-1 top-100 end-0 bg-white shadow p-2 rounded">
              <a className="btn btn-light w-100 mb-2" href="/setting">
                My Account
              </a>
              <button className="btn btn-danger w-100" onClick={handleLogout}>
                <FaSignOutAlt /> Logout
              </button>
            </div>
          )}
        </div>
      </nav>

      <div className="sidebar-container">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} user={userData} />
      </div>
      <div className="toggle-overlay" onClick={toggleSidebar}></div>
    </header>
  );
};

export default Header;